/*
 *  -----------------------------------------------------------------------
 *    <copyright file="manage-signatories-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { TFunction } from 'i18next';
import { IExpandableGridColumnV2 } from '@components/core/expandable/grid-v2/interfaces-v2/grid-props-v2.interface';
import { GridColumnDateFilter } from '@components/core/grid-filters';
import { useGridCells } from '@hooks/index';

const { DateCell, MaxLengthCell } = useGridCells();

export const MANAGE_SIGNATORIES_COLUMNS = (t: TFunction): IExpandableGridColumnV2[] => [
    {
        label: t('firstName'),
        field: 'firstName',
        id: 'signatory-first-name',
        headerClass: 'border',
        minWidth: 208,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('lastName'),
        field: 'lastName',
        id: 'signatory-last-name',
        headerClass: 'border',
        minWidth: 208,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('reports:jobTitle'),
        field: 'jobTitle',
        id: 'signatory-job-title',
        headerClass: 'border',
        minWidth: 208,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('ra:createdBy'),
        field: '_createdByString',
        headerClass: 'border',
        id: 'signatory-createdby',
        showByDefault: false,
        minWidth: 136,
    },
    {
        label: t('ra:createdDate'),
        field: 'createdDate',
        headerClass: 'border',
        filter: 'date',
        id: 'signatory-created',
        showByDefault: false,
        minWidth: 138,
        cells: { data: DateCell },
        filterUi: GridColumnDateFilter,
    },
    {
        label: t('ra:updatedBy'),
        field: '_updatedByString',
        headerClass: 'border',
        id: 'signatory-updatedby',
        showByDefault: false,
        minWidth: 142,
    },
    {
        label: t('ra:updatedDate'),
        field: 'updatedDate',
        headerClass: 'border',
        filter: 'date',
        id: 'risk-updated',
        showByDefault: false,
        minWidth: 146,
        cells: { data: DateCell },
        filterUi: GridColumnDateFilter,
    },
    {
        label: t('id'),
        field: '_itemId',
        minWidth: 150,
        id: 'template-id',
        showByDefault: false,
    },
];
